module.exports = __webpack_public_path__ + "856cab912ded136de723e526c8ab5f04.svg";